export enum EInstance {
  ASM = 'pinpoint.asm-yachts.com',
  STAGING = 'staging.pinpointworks.com',
  DEVELOPMENT = 'dev.pinpointworks.com',
  LIVE = 'app.pinpointworks.com',
  LOCALHOST = 'localhost',
}
